import { Reducer } from "redux";
import { Models, Types, Components } from "@sendum/core";

const cloneDeep = require("lodash/cloneDeep");

import { DispatchAction } from "./MapStore";
import { MapActionTypes } from "./MapActions";
import * as L from "leaflet";


export interface IMapState {
	isLoadingDevices?: boolean;
	error?: Error;
	devices?: Models.Device[];
	pins?: Types.TPin[];
}

const initialState: IMapState = {
	isLoadingDevices: true,
	devices: new Array<Models.Device>(),
};

const setLoadingDevices = (state: IMapState, payload: any): IMapState => ({
	isLoadingDevices: payload.newState,
	error: payload.newState ? undefined : state.error,
});

const updatePin = (state: IMapState, payload: any): IMapState => {
	const { lat, lon, topic, deviceId } = payload;
	if (isNaN(lat) || isNaN(lon) || !topic) {
		return {};
	}

	let updated_index = null;
	const newPins = state.pins || new Array<Types.TPin>();
	newPins.forEach((pin: Types.TPin, index: number) => {
		if (pin.device && topic === pin.device.shipment.id && deviceId === pin.device.id) {
			updated_index = index;
		}
	});
	if (updated_index !== null) {
		newPins[updated_index].position = new L.LatLng(lat, lon);
	}

	return { pins: newPins };
};

const updateDeviceMQTT = (state: IMapState, payload: any): IMapState => {
	const delta: IMapState = {};
	if (!payload.mess.Device || !state.devices) {
		return delta;
	}
	const device: Models.Device | undefined = state.devices.find(d => d?.id === payload.mess.Device && d?.shipment?.id === payload.topic);

	if (!device?.id || !device.present) {
		return {};
	}
	device.present.update(payload.mess);
	device.updateAlarms(payload.mess);
	delta.devices = [...state.devices];
	const index = delta.devices.findIndex(d => d?.id === device?.id && d?.shipment?.id === device?.shipment?.id);
	if (index !== -1) {
		delta.devices[index] = cloneDeep(device);
		delta.pins = Components.MapUtils.buildPins(delta.devices);
	}

	return delta;
};

export const MapReducer: Reducer<IMapState, DispatchAction> = (state = initialState, action) => {
	switch (action.type) {
		case MapActionTypes.SET_LOADING_DEVICES: {
			return { ...state, ...setLoadingDevices(state, action.payload) };
		}
		case MapActionTypes.ADD_PINS: {
			const pins = state.pins ? [...state.pins] : [];

			return { ...state, ...{ pins: [...pins, ...action.payload.pins] } };
		}
		case MapActionTypes.ADD_DEVICES: {
			const ids = new Set(action.payload.devices.map((d: Models.Device) => `${d.id}#${d.shipment.id}`));
			const devices = state.devices ? [...state.devices] : [];

			return { ...state, ...{ devices: [...devices.filter(d => !ids.has(`${d.id}#${d.shipment.id}`)), ...action.payload.devices] } };
		}
		case MapActionTypes.UPDATE_PIN: {
			return { ...state, ...updatePin(state, action.payload) };
		}
		case MapActionTypes.UPDATE_DEVICE_MQTT: {
			return { ...state, ...updateDeviceMQTT(state, action.payload) };
		}
		case MapActionTypes.SET_ERROR: {
			return { ...state, ...{ error: action.payload.error } };
		}
		case MapActionTypes.CLEAR_DATA: {
			return { ...state, ...{ devices: [], pins: [] } };
		}
		case MapActionTypes.RESET_STATE: {
			return { ...initialState };
		}
		default:
			return state;
	}
};
